<template>
  <div>
    <div v-if="matrix2_view">
      <ButtonMedium
        :click_button="
          () => $bvModal.show('remove-egress-profile-matters-modal')
        "
        :tooltip_text="`${$t('reusable.common.delete')} ${$getVisibleNames(
          'mesh.egressprofilematter',
          false,
          'Asignaturas'
        )}`"
        :custom_class="`mb-2 ml-3`"
        :icon="'trash'"
        :variant="'danger'"
      ></ButtonMedium>
      <b-modal
        id="remove-egress-profile-matters-modal"
        :title="`${$t('reusable.common.delete')} ${$getVisibleNames(
          'mesh.egressprofilematter',
          true,
          'Asignaturas'
        )}`"
        size="xl"
        @hide="hideModals"
        hide-footer
      >
        <GenericBTable
          :items="matterList"
          :fields="fields"
          :filter="input_search"
          :filter-included-fields="filterOn"
          :filterCustom="filterCustom"
          :show_pagination="true"
          :search_filter="true"
          :selection_mode="true"
          :columns_display="false"
          :pagination="10"
          :per_page="10"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @emitChangeSearchField="changeInputSearch"
        >
          <template #head(selected)>
            <b-form-checkbox
              v-model="select_all"
              @change="selectAllEPMatter()"
            ></b-form-checkbox>
          </template>
          <template #cell(selected)="row">
            <b-checkbox
              v-model="row.item.selected"
              @change="selectEPMatter(row.item.id, $event)"
            ></b-checkbox>
          </template>
        </GenericBTable>
        <h4 v-if="selected.length > 0">
          {{
            $getVisibleNames("mesh.egressprofilematter", true, "Asignaturas")
          }}
          {{ $t("curricularProducts.egressProfile.selected") }}
        </h4>
        <div class="matters-container">
          <div
            v-for="item in matterList.filter((x) => selected.includes(x.id))"
            :key="item.id"
            class="matters-div"
          >
            {{ (matters.find((x) => x.id == item.matter) || {}).name || "" }}
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: right">
            <template v-if="selected.length > 0">
              <b-button class="mr-1" size="sm" @click="removeMatters()">
                {{ $t("curricularProducts.egressProfile.remove") }}
                {{
                  $getVisibleNames(
                    "mesh.egressprofilematter",
                    true,
                    "Asignaturas"
                  )
                }}
              </b-button>
            </template>
            <template v-else>
              <b-button class="mr-1" size="sm" disabled
                >{{ $t("curricularProducts.egressProfile.remove") }}
                {{
                  $getVisibleNames(
                    "mesh.egressprofilematter",
                    true,
                    "Asignaturas"
                  )
                }}</b-button
              >
            </template>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-else>
      <div class="d-flex">
        <h3 v-if="!copy_egress_profile_view" class="ml-4">
          {{
            $getVisibleNames("mesh.egressprofilematter", true, "Asignaturas")
          }}
        </h3>
        <div class="ml-3" v-if="!copy_egress_profile_view">
          <template v-if="selected.length > 0">
            <b-button class="mr-1" size="sm" @click="TemporalChangedMatters()"
              >{{ $t("curricularProducts.egressProfile.reassignLevel") }} "{{
                semester_amount
              }}" {{ $t("curricularProducts.egressProfile.to") }}
              {{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  true,
                  "Asignaturas"
                )
              }}
              {{ $t("curricularProducts.egressProfile.selected") }}</b-button
            >
          </template>
          <template v-else>
            <b-button class="mr-1" size="sm" disabled
              >{{ $t("curricularProducts.egressProfile.reassignLevel") }} "{{
                semester_amount
              }}" {{ $t("curricularProducts.egressProfile.to") }}
              {{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  true,
                  "Asignaturas"
                )
              }}
              {{ $t("curricularProducts.egressProfile.selected") }}</b-button
            >
          </template>
        </div>
      </div>
      <GenericBTable
        :items="matterList"
        :fields="fields"
        :filter="input_search"
        :filter-included-fields="filterOn"
        :filterCustom="filterCustom"
        :show_pagination="true"
        :search_filter="true"
        :selection_mode="true"
        :columns_display="false"
        :pagination="10"
        :per_page="10"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @emitChangeSearchField="changeInputSearch"
      >
        <template #head(selected)>
          <b-form-checkbox
            v-model="select_all"
            @change="selectAllEPMatter()"
          ></b-form-checkbox>
        </template>
        <template #cell(selected)="row">
          <b-checkbox
            v-model="row.item.selected"
            @change="selectEPMatter(row.item.id, $event)"
          ></b-checkbox>
        </template>
        <template #cell(plan_level)="row">
          <b-form-input
            style="width: auto"
            type="number"
            min="1"
            v-model="row.item.plan_level"
            @update="updateInput()"
            :state="
              row.item.plan_level <= semester_amount && row.item.plan_level >= 1
            "
            v-b-tooltip.v-danger.noninteractive="
              row.item.plan_level <= semester_amount && row.item.plan_level >= 1
                ? ''
                : $t(
                    'curricularProducts.egressProfile.planLevelExceedsProfile',
                    {
                      matter: $getVisibleNames(
                        'mesh.egressprofilematter',
                        false,
                        'Asignatura'
                      ),
                      profile: $getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      ),
                    }
                  )
            "
            size="sm"
          ></b-form-input>
        </template>
        <!-- <template #cell(actions)="row">
          <button-edit
            v-if="!matrix2_view"
            @click="
              $bvModal.show(`edit-egress-profile-matter-modal-${row.item.id}`)
            "
            v-b-tooltip.v-secondary.noninteractive="
              `Editar ${$getVisibleNames(
                'mesh.egressprofilematter',
                false,
                'Asignatura'
              )}`
            "
          ></button-edit>
          <b-modal
            :id="`edit-egress-profile-matter-modal-${row.item.id}`"
            hide-footer
            :title="`Editar ${$getVisibleNames(
              'mesh.egressprofilematter',
              false,
              'Asignatura'
            )}`"
            size="lg"
          >
            <MatterForm
              :Matter="row.item"
              :egress_profile_id="row.item.egress_profile"
              :show_delete_button="true"
              @update="
                $bvModal.hide(`edit-egress-profile-matter-modal-${row.item.id}`)
              "
              @updated="
                $bvModal.hide(`edit-egress-profile-matter-modal-${row.item.id}`)
              "
            ></MatterForm>
          </b-modal>
        </template> -->
      </GenericBTable>
      <div class="d-block">
        <template v-if="selected.length > 0 && !copy_egress_profile_view">
          <div class="copy-selection-panel ml-3 mb-3">
            <div class="copy-selection-header">
              <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
              {{ selected.length }}
              {{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  true,
                  "Asignaturas"
                )
              }}
              {{ $t("curricularProducts.egressProfile.selectedToNotBeCopied") }}
            </div>
            <div class="matters-container mb-2">
              <div
                v-for="item in matterList.filter((x) =>
                  selected.includes(x.id)
                )"
                :key="item.id"
                class="matters-div"
              >
                {{
                  (matters.find((x) => x.id == item.matter) || {}).name || ""
                }}
              </div>
            </div>
            <b-button
              size="sm"
              variant="danger"
              @click="TemporalRemoveMatters()"
            >
              <b-icon icon="x-circle" class="mr-1" scale="0.9"></b-icon>
              {{ $t("curricularProducts.egressProfile.remove") }}
              {{ $t("curricularProducts.egressProfile.selected") }}
            </b-button>
          </div>
        </template>
        <template v-if="remove_matters.length > 0">
          <div class="d-block ml-2">
            <h5>
              <template v-if="copy_egress_profile_view"
                >{{ $t("curricularProducts.egressProfile.listOf") }}
              </template>
              {{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  true,
                  "Asignaturas"
                )
              }}
              <template v-if="!copy_egress_profile_view">
                {{ $t("curricularProducts.egressProfile.toDelete") }}
              </template>
              <template v-else>
                {{
                  $t("curricularProducts.egressProfile.thatWillNotBeCopied")
                }}</template
              >
            </h5>
            <div class="matters-container">
              <div
                v-for="item in remove_matters"
                :key="item.id"
                class="matters-div deleted-matter"
              >
                {{
                  (matters.find((x) => x.id == item.matter) || {}).name || ""
                }}
                <b-button
                  variant="none"
                  size="sm"
                  class="m-0 p-0"
                  @click="reintegrateMatters(item)"
                >
                  <b-icon
                    icon="x-square"
                    scale="0.9"
                    variant="white"
                    v-b-tooltip.v-secondary.noninteractive="
                      `${$t(
                        'curricularProducts.egressProfile.integrate'
                      )} ${$getVisibleNames(
                        'mesh.egressprofilematter',
                        false,
                        'Asignatura'
                      )}`
                    "
                  ></b-icon>
                </b-button>
              </div>
            </div>
            <b-button
              v-if="copy_egress_profile_view"
              size="sm"
              variant="outline-secondary"
              class="mt-2"
              @click="reintegrateAllMatters()"
            >
              <b-icon icon="arrow-counterclockwise" class="mr-1" scale="0.9"></b-icon>
              {{ $t("curricularProducts.egressProfile.reintegrateAll") }}
            </b-button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
// import { generateUniqueId } from "@/utils/utils";
export default {
  name: "RemoveEPMattersComponent",
  components: {
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),

    // MatterForm: () => import("./MatterForm"),
  },
  props: {
    allows_crud: {
      type: Boolean,
    },
    matrix2_view: {
      type: Boolean,
      default: true,
    },
    copy_egress_profile_view: {
      type: Boolean,
      default: false,
    },
    egress_profile_id: {
      type: Number,
      required: true,
    },
    semester_amount: {
      default: 1,
    },
  },
  data() {
    return {
      select_all: false,
      selected: [],
      filterOn: [],
      list_matters: [],
      sortBy: "",
      sortDesc: "",
      input_search: "",
      remove_matters: [],
    };
  },
  computed: {
    ...mapGetters({
      matters: names.MATTERS,
      egressProfileMatters: names.EGRESS_PROFILES_MATTERS,
    }),
    matterList() {
      if (this.matrix2_view) {
        let list = [
          ...this.egressProfileMatters.filter(
            (x) => x.egress_profile == this.egress_profile_id
          ),
        ];
        return list.sort(function (a, b) {
          if (a.plan_level > b.plan_level) return 1;
          if (a.plan_level < b.plan_level) return -1;
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
      } else {
        let list = this.list_matters;
        return list.sort(function (a, b) {
          if (a.plan_level > b.plan_level) return 1;
          if (a.plan_level < b.plan_level) return -1;
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
      }
    },
    fields() {
      let list = [
        {
          key: "selected",
          label: this.copy_egress_profile_view
            ? this.$t("curricularProducts.egressProfile.exclude")
            : this.$t("curricularProducts.egressProfile.select"),
          display_column: true,
          thStyle: { width: "1%" },
        },
        {
          key: "plan_level",
          label: this.$t("curricularProducts.egressProfile.planLevel"),
          display_column: true,
          tdClass: "text-center",
          tdStyle: { width: "auto" },
          thStyle: {
            width: "10%",
          },
        },
        {
          key: "id",
          label: this.$getVisibleNames("manual.matter_code", false, "Código"),
          formatter: (value) => {
            return (
              (this.egressProfileMatters.find((x) => x.id == value) || {})
                .effective_code || ""
            );
          },
          display_column: true,
        },
        {
          key: "matter",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          ),
          formatter: (value) => {
            return (this.matters.find((x) => x.id == value) || {}).name || "";
          },
          display_column: true,
        },
        // {
        //   key: "actions",
        //   label: "",
        //   display_column: !this.matrix2_view ? true : false,
        //   thClass: "noprint",
        //   tdClass: "noprint",
        // },
      ];
      return list;
    },
  },
  methods: {
    removeMatters() {
      this.$swal({
        title: this.$t(
          "curricularProducts.egressProfile.wantToRemoveSelected",
          {
            entities: this.$getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            ),
          }
        ),
        width: "auto",
        text: this.$t(
          "curricularProducts.egressProfile.actionWillUnlinkObjects",
          {
            entity: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
          }
        ),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          //   footer: `
          //   <div class="block">
          //   <h3 v-if="${this.selected.length > 0}">
          //   ${this.$getVisibleNames(
          //     "mesh.egressprofilematter",
          //     true,
          //     "Asignaturas"
          //   )}
          //   Seleccionadas
          // </h3>
          //   <div style="display: flex;flex-direction: row;flex-wrap: wrap;">
          //   ${this.matterList
          //     .filter((x) => this.selected.includes(x.id))
          //     .map(
          //       (
          //         render
          //       ) => `<div style="background-color: rgb(153,201,216);color: white;max-width: fit-content;border-radius: 3px;margin: 0.1em 0.1em;padding: 1px 4px;flex-grow: 1;font-size: 9pt;text-align: center;" :key="${
          //         render.id
          //       }"> ${
          //         (this.matters.find((x) => x.id == render.matter) || {}).name || ""
          //       }</div>
          //     `
          //     )
          //     .join("")}</div>
          // `,
          this.removeMatterAndCourses(this.selected);
          this.$bvModal.hide("remove-egress-profile-matters-modal");
        }
      });
    },
    async removeMatterAndCourses(egress_profile_filter) {
      for await (let ep_matter_id of egress_profile_filter) {
        await this.$store.dispatch(
          names.DELETE_EGRESS_PROFILE_MATTER,
          ep_matter_id
        );
      }
      this.selected = [];
      this.select_all = false;
    },
    updateInput() {
      this.$emit("list_matters", this.list_matters, this.remove_matters);
    },
    TemporalRemoveMatters() {
      this.list_matters
        .filter((x) => this.selected.includes(x.id))
        .forEach((x) => {
          x.selected = false;
          this.remove_matters.push(x);
          const index = this.list_matters.findIndex((a) => a.id == x.id);
          if (index != -1) this.list_matters.splice(index, 1);
        });
      this.selected = [];
      this.select_all = false;
      this.$emit("list_matters", this.list_matters, this.remove_matters);
    },
    TemporalChangedMatters() {
      this.list_matters
        .filter((x) => this.selected.includes(x.id))
        .forEach((x) => {
          x.plan_level = this.semester_amount;
          x.selected = false;
        });
      this.selected = [];
      this.select_all = false;
      this.$emit("list_matters", this.list_matters, this.remove_matters);
    },
    reintegrateMatters(matter) {
      const index = this.remove_matters.findIndex((x) => x.id == matter.id);
      if (index != -1) {
        this.remove_matters.splice(index, 1);
        this.list_matters.push(matter);
      }
      this.$emit("list_matters", this.list_matters, this.remove_matters);
      this.select_all = false;
    },
    reintegrateAllMatters() {
      while (this.remove_matters.length > 0) {
        this.list_matters.push(this.remove_matters.pop());
      }
      this.$emit("list_matters", this.list_matters, this.remove_matters);
      this.select_all = false;
    },
    hideModals() {
      this.select_all = false;
      this.selected = [];
      this.matterList.forEach((x) => {
        x.selected = false;
      });
    },
    filterCustom(row) {
      if (
        this.$filtered(
          (this.matters.find((x) => x.id == row.matter) || {}).name || "",
          this.input_search
        ) ||
        this.$filtered(row.effective_code || "", this.input_search) ||
        this.$filtered(row.plan_level, this.input_search)
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectEPMatter(matter_id) {
      if (this.copy_egress_profile_view) {
        this.directExcludeMatter(matter_id);
        return;
      }
      const index = this.selected.findIndex((x) => x == matter_id);
      if (index != -1) this.selected.splice(index, 1);
      else this.selected.push(matter_id);
    },
    directExcludeMatter(matter_id) {
      const index = this.list_matters.findIndex((x) => x.id == matter_id);
      if (index != -1) {
        const matter = this.list_matters[index];
        matter.selected = false;
        this.remove_matters.push(matter);
        this.list_matters.splice(index, 1);
        this.$emit("list_matters", this.list_matters, this.remove_matters);
      }
    },
    selectAllEPMatter() {
      if (this.copy_egress_profile_view) {
        if (this.select_all) {
          const ids = this.list_matters.map((x) => x.id);
          ids.forEach((id) => this.directExcludeMatter(id));
        }
        this.select_all = false;
        return;
      }
      let list = [];
      if (!this.select_all) {
        this.matterList.forEach((x) => {
          x.selected = false;
        });
        this.selected = [];
      } else {
        this.matterList.forEach((x) => {
          list.push(x.id);
          x.selected = true;
        });
        this.selected = [...new Set(list)];
      }
    },
    changeInputSearch(input_search) {
      if (input_search) this.input_search = input_search;
    },
  },
  watch: {
    selected() {
      if (
        this.selected.length == this.matterList.length &&
        this.matterList.length > 0
      ) {
        this.select_all = true;
      } else if (
        this.selected.length != this.matterList.length &&
        this.matterList.length > 0
      )
        this.select_all = false;
    },
  },
  mounted() {
    this.select_all = false;
    this.selected = [];
    this.list_matters = [];
    if (!this.matrix2_view) {
      if (!this.copy_egress_profile_view) {
        this.list_matters = this.egressProfileMatters
          .filter(
            (x) =>
              x.egress_profile == this.egress_profile_id &&
              x.plan_level > this.semester_amount
          )
          .map((objeto) => ({ ...objeto }));
      } else {
        this.list_matters = this.egressProfileMatters
          .filter((x) => x.egress_profile == this.egress_profile_id)
          .map((objeto) => ({ ...objeto }));
      }
      this.$emit("list_matters", this.list_matters, this.remove_matters);
    }
  },
  created() {},
};
</script>

<style scoped>
.matters-div {
  background-color: var(--primary-color);
  color: white;
  max-width: fit-content;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  flex-grow: 1;
  font-size: var(--thirth-font-size);
  text-align: center;
}
.deleted-matter {
  background-color: red !important;
}
.matters-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.copy-selection-panel {
  padding: 0.75rem;
  background-color: #fff8e1;
  border: 1px solid #ffcc02;
  border-radius: 6px;
}
.copy-selection-header {
  font-weight: 600;
  font-size: var(--secondary-font-size, 0.9rem);
  margin-bottom: 0.5rem;
  color: #856404;
}
</style>